import React from 'react';

const EB2NIW: React.FC = () => (
  <div className="bg-white min-h-screen text-left flex flex-col items-center py-10 px-4 pt-20">
    <div className="max-w-7xl w-full px-0 md:px-10">
      <h1 className="text-3xl md:text-4xl font-extrabold text-[#0097b2] mb-4 leading-tight">EB2-NIW (National Interest Waiver)</h1>
      <div className="text-[22px] text-gray-700 mb-4">This page is under construction.</div>
    </div>
  </div>

);

export default EB2NIW;
